//Please add the language resource
const epod = {
  customerCode:'CustomerCode',
  customerShortName:'CustomerShortName',
  customerName: 'CustomerName',
  customerAddr: 'CustomerAddr',
  tradeLineCode:'TradeLineCode',
  tradeLineName:'TradeLineName',
  businessType:'BusinessType',
  mnemonicCode:'MnemonicCode',
  contact:'Contact',
  tel: 'Tel',
  email:'Email',
  createTime:'CreateTime',
  creator:'Creator',
  updateTime:'UpdateTime',
  updater:'Updater',
  msg:{
  }
};
export default epod



// WEBPACK FOOTER //
// ./src/page/transport/epod/lang/epod.en.js